<script>
import AdminLayout from '@layouts/admin-main'
import WithdrawList from '@components/admin/withdraw-list'

export default {
  page: {
    title: 'Admin::WithdrawList',
    meta: [{ name: 'description', content: 'Admin::WithdrawList' }],
  },
  components: { AdminLayout, WithdrawList },
}
</script>

<template>
  <AdminLayout>
    <WithdrawList></WithdrawList>
  </AdminLayout>
</template>

<style lang="scss" module>
@import '@design';
</style>
